import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { TeachersState, TeachersApiResponse, TeachersDetailsApiResponse } from '../types';

const initialState: TeachersState = {
  teachers: [],
  teachersDetails: undefined!,
};

const teachersSlice = createSlice({
  name: 'teachers',
  initialState,
  reducers: {
    setTeachersAction(state, action: PayloadAction<TeachersApiResponse>) {
      state.teachers = action.payload.teachers;
    },

    clearTeachersAction(state) {
      state.teachers = [];
    },

    setTeachersDetailsAction(state, action: PayloadAction<TeachersDetailsApiResponse>) {
      state.teachersDetails = action.payload;
    },

    clearTeachersDetailsAction(state) {
      state.teachersDetails = undefined!;
    },
  },
});

export const {
  setTeachersAction,
  clearTeachersAction,
  setTeachersDetailsAction,
  clearTeachersDetailsAction,
} = teachersSlice.actions;

export const getTeachers = (state: RootState): TeachersState => state.teachers;

export default teachersSlice.reducer;
